import React from 'react';
import groupDiscussion from "../../../assets/images/groupDiscussion.png";

const GdReadyToPresent = ({ showButton, onPress }) => {
  return (
    <div className="flex flex-1 flex-col justify-center items-center bg-white h-full">
      <div className="flex justify-center items-center mb-4">
        <img
          src={groupDiscussion}
          alt="Group Discussion"
          className="object-contain"
          style={{ height: '10%', width: '10%' }}
        />
      </div>
      <span className="text-base text-gray-800 text-center mb-4">
        Trainer would like you to volunteer for group presentations
      </span>
      {showButton && (
        <button
          className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          onClick={onPress}
        >
          Ready to Present
        </button>
      )}
    </div>
  );
};

export default GdReadyToPresent;